import Vue from 'vue';
import Router from 'vue-router';
import Swal from 'sweetalert2';
import MainPage from '@/components/MainPage.vue';
import LogReg from '@/components/Log_Reg.vue';
import HouseReviewScore from '@/components/HouseReviewScore.vue';
import RegInfo from '@/components/RegInfo.vue';
import RateTheHouse from '@/components/rateTheHouse.vue';
import recommendHouse from '@/components/recommendHouse.vue'
import AddHouse from '@/components/AddHouse.vue';
import userInfo from '@/components/userInfo.vue';
import userProfile from '@/components/userProfile.vue';
import mapDraw from '@/components/mapDraw';
import addLocation from '@/components/addLocation.vue';
import SweetAlertTest from '@/components/SweetAlertTest.vue';
import showReview from '@/components/showReview.vue';
import editReview from '@/components/editReview.vue';
import editComment from  '@/components/editComment.vue';
import AddHouseRoom from '@/components/AddHouseRoom.vue';
import recommendHouseUniversity from '@/components/recommendHouse_university.vue';
import recommendHouseCompany from '@/components/recommendHouse_company.vue';
import rewardAdmin from '@/components/rewardAdmin.vue';
import AdminLocations from '@/components/AdminLocations.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import TermsOfUse from '@/components/TermsOfUse.vue';
import { hasValidStoredToken } from '@/utils/auth';
import i18n from '@/i18n';
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/', name: 'MainPage', component: MainPage
    },
    {
      path: '/LogReg',
      name: 'LogReg',
      component: LogReg
    },
        {
      path: '/AddHouseRoom',
      name: 'AddHouseRoom',
      component: AddHouseRoom
    },
     {
      path: '/showReview',
      name: 'showReview',
      component: showReview
    },
     {
      path: '/editReview',
      name: 'editReview',
      component: editReview
    },
         {
      path: '/editComment',
      name: 'editComment',
      component: editComment
    },
    {
      path: '/AddLocation',
      name: 'AddLocation',
      component: addLocation
    },
{
      path: '/mapDraw',
      name: 'mapDraw',
      component: mapDraw
    },
    {
      path: '/RegInfo',
      name: 'RegInfo',
      component: RegInfo
    },
    {
      path: '/MainPage',
      redirect: '/'
    },{
      path:'/HouseReviewScore',
      name:'HouseReviewScore',
      component:HouseReviewScore
    },
    {
      path:'/rateTheHouse',
      name:'rateTheHouse',
      component:RateTheHouse
    },
    {
      path:'/recommendHouse',
      name:'recommendHouse',
      component:recommendHouse
    },
            {
      path:'/recommendHouseUniversity',
      name:'recommendHouseUniversity',
      component:recommendHouseUniversity
    },
        {
      path:'/recommendHouseCompany',
      name:'recommendHouseCompany',
      component:recommendHouseCompany
    },
    {
      path:'/AddHouse',
      name:'AddHouse',
      component:AddHouse
    },
    {
      path:'/userInfo',
      name:'userInfo',
      component:userInfo
    },
    {
      path:'/userProfile',
      name:'userProfile',
      component:userProfile
    },
    {
      path:'/rewardAdmin',
      name:'rewardAdmin',
      component:rewardAdmin
    },
    {
      path:'/adminLocations',
      name:'adminLocations',
      component:AdminLocations
    },
    {
      path: '/sweetalert-test',
      name: 'SweetAlertTest',
      component: SweetAlertTest
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/terms-of-use',
      name: 'TermsOfUse',
      component: TermsOfUse
    },
    // 其他路由配置...
  ],
  scrollBehavior() {
    // 每次跳转后滚动到页面顶部
    return { x: 0, y: 0 };
  }

});

// Routes that require login. Writing/editing anything review-related, plus
// per-user pages. Reading (MainPage, HouseReviewScore) stays public.
// /showReview handles its own blurred-content login gate at the component level.
const PROTECTED_ROUTES = new Set([
  'AddHouse',
  'AddHouseRoom',
  'rateTheHouse',
  'editReview',
  'editComment',
  'AddLocation',
  'userInfo',
  'userProfile',
  'rewardAdmin',
  'adminLocations',
]);

const ADMIN_ONLY_ROUTES = new Set([
  'rewardAdmin',
  'adminLocations',
]);

router.beforeEach((to, from, next) => {
  if (PROTECTED_ROUTES.has(to.name) && !hasValidStoredToken()) {
    Swal.fire({
      icon: 'info',
      title: i18n.t('auth.loginRequiredTitle'),
      text: i18n.t('auth.loginRequiredText'),
      confirmButtonText: i18n.t('auth.loginRequiredConfirm'),
      confirmButtonColor: '#6366f1',
      showCancelButton: true,
      cancelButtonText: i18n.t('auth.loginRequiredCancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        next({ path: '/LogReg', query: { redirect: to.fullPath } });
      } else {
        next(false);
      }
    });
    return;
  }
  if (ADMIN_ONLY_ROUTES.has(to.name) && String(localStorage.getItem('role') || '').toLowerCase() !== 'admin') {
    Swal.fire({
      icon: 'error',
      title: i18n.t('auth.adminOnlyTitle'),
      text: i18n.t('auth.adminOnlyText'),
      confirmButtonColor: '#6366f1',
    }).then(() => {
      next({ path: '/' });
    });
    return;
  }
  next();
});

export default router;
